export const CONTACT_FB_URL = "https://www.facebook.com/fyzencareersolutions/";
export const CONTACT_IN_URL = "https://in.linkedin.com/company/fyzen-career-solutions";
export const CONTACT_EM_URL = "mailto:fyzencareer@gmail.com";
export const CONTACT_WB_URL = "https://www.facebook.com/fyzencareersolutions/";